import { useTexts } from '../hooks/useTexts'
import { createValidateSurname } from '../hooks/validations/createValidateSurname'

import { form } from '../formState'

export function Surname() {
  const texts = useTexts()

  form.useAddFieldValidation<'surname'>('surname', (field, _formApi) => {
    const validationSurName = createValidateSurname(texts, field.value)
    return (
      validationSurName.surnameRequiredError?.message ||
      validationSurName.surnameMaxLengthError?.message
    )
  })

  return (
    <form.TextField
      testId="surname"
      name="surname"
      label={texts.labels.surname}
      placeholder={texts.placeholders.surname}
      validateOn="change"
    />
  )
}
